import React, { PureComponent } from 'react';
import { IPart } from 'types';
// Components
import Form, { TextField, FileUploadField } from 'ui/form';
import Button from 'ui/button';
interface PartFormProps {
  part?: IPart;
  header?: string;
  onSave: (part: IPart) => void;
  onCancel: () => void;
}
export default class PartForm extends PureComponent<PartFormProps> {
  handleSubmit = (model: IPart) => {
    this.props.onSave({ ...this.props.part, ...model });
  };
  render() {
    const { header, onCancel } = this.props;
    return (
      <Form onSubmit={this.handleSubmit} onCancel={onCancel} formData={this.props.part} noButtons>
        <div className="row">
          <FileUploadField className="margin" name="image" label="Image" dir="part" />
          <div className="flex margin">
            {header && <h2>{header}</h2>}
            <TextField name="name" label="Part name" autoFocus />
            <TextField name="description" label="Part description" multiline />

            <Button type="submit" flat="Save" primary className="tiny-margin" />
            <Button flat="Cancel" onClick={onCancel} className="tiny-margin" />
          </div>
        </div>
      </Form>
    );
  }
}
